import { recipientSchema } from '@newfront-insurance/ai-api';
import { z } from 'zod';

export const emailDraftPreviewContextSchema = z.object({
  mailboxAddress: z.string().optional(),
  originalMessage: z
    .object({
      from: recipientSchema.optional(),
      receivedDateTime: z.string().optional(),
      subject: z.string().optional(),
      bodyPreview: z.string().optional(),
      webLink: z.string().url().optional(),
    })
    .optional(),
});
export type EmailDraftPreviewContext = z.infer<typeof emailDraftPreviewContextSchema>;

const outlookDraftStateSchema = z.object({
  status: z.literal('created'),
  draftId: z.string().min(1),
  webLink: z.string().url().optional().catch(undefined),
  createdAt: z.string().datetime().optional().catch(undefined),
  mailboxAddress: z.string().optional(),
});
export type OutlookDraftState = z.infer<typeof outlookDraftStateSchema>;

export interface OutlookDraftAction {
  state?: OutlookDraftState;
  canCreate: boolean;
  pending: boolean;
  error?: string;
  create: () => Promise<void>;
}

export function getOutlookDraftState(part: unknown): OutlookDraftState | undefined {
  const result = z.object({ output: z.object({ outlookDraft: outlookDraftStateSchema }) }).safeParse(part);
  return result.success ? result.data.output.outlookDraft : undefined;
}
